import React, { useState, useMemo } from 'react'
import styled from 'styled-components'
import { Tooltip } from '../QuestionHelper'
import { Loader } from 'react-feather'
import useGithubJson, { BASE_CHAIN_ID, JsonFilePath } from '../../hooks/useGithubJson'

const TextWrapper = styled.div`
  position: relative;
  margin-left: ${({ margin }) => margin && '4px'};
  color: ${({ theme, link }) => (link ? theme.blue : theme.text1)};
  font-size: ${({ fontSize }) => fontSize ?? 'inherit'};

  :hover {
    cursor: pointer;
  }

  @media screen and (max-width: 600px) {
    font-size: ${({ adjustSize }) => adjustSize && '12px'};
  }
`

const FormattedName = ({
  text,
  maxCharacters,
  margin = false,
  adjustSize = false,
  fontSize,
  link,
  address,
  needVerifiedIcon = false,
  ...rest
}) => {
  const [showHover, setShowHover] = useState(false)
  const { jsonData } = useGithubJson(JsonFilePath.VERIFY_STATS)
  const isVerified = useMemo(
    () =>
      needVerifiedIcon &&
      jsonData?.[BASE_CHAIN_ID]?.verifiedTokenList &&
      jsonData[BASE_CHAIN_ID].verifiedTokenList.includes(address),
    [address, jsonData, needVerifiedIcon]
  )

  if (!text) {
    return ''
  }

  if (text.length > maxCharacters) {
    return (
      <Tooltip text={text} show={showHover}>
        <TextWrapper
          onMouseEnter={() => setShowHover(true)}
          onMouseLeave={() => setShowHover(false)}
          margin={margin}
          adjustSize={adjustSize}
          link={link}
          fontSize={fontSize}
          {...rest}
        >
          {' ' + text.slice(0, maxCharacters - 1) + '...'}
        </TextWrapper>
      </Tooltip>
    )
  }

  return (
    <TextWrapper margin={margin} adjustSize={adjustSize} link={link} fontSize={fontSize} {...rest}>
      {text}
      {isVerified && (
        <>
          {jsonData?.[BASE_CHAIN_ID]?.verifiedIcon ? (
            <img
              src={jsonData[BASE_CHAIN_ID]?.verifiedIcon}
              alt="verified"
              style={{ width: '1.2rem', height: '1.2rem', marginLeft: '.5rem', verticalAlign: 'middle' }}
            />
          ) : (
            <Loader style={{ width: '1.2rem', height: '1.2rem', marginLeft: '.5rem', verticalAlign: 'middle' }} />
          )}
        </>
      )}
    </TextWrapper>
  )
}

export default FormattedName
